import moment from "moment";
/**
 * [formatOrdinalNumber Formats a number to ordinal format. For example, 1 -> 1st, 2 -> 2nd
 * @param  {Number} input
 *
 * @return {Number}
 */
export default function formatOrdinalNumber(input) {
  return moment.localeData().ordinal(input);
}
